import moment from 'moment';
import 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { callEndpoint, telemetry } from '../../../../services/backend';
import { ROUTE_REMINDERS } from '../../../../services/route/route-names';
import {
  transitionToNextRoute,
  transitionToPreviousRoute,
} from '../../../../services/route/route-navigation';
import { setSideBarNoMenu } from '../../../../services/store/modules/app-controls';
import BasicDrawerLayout from '../../../layouts/BasicDrawerLayout/BasicDrawerLayout';
import ErrorMessage from '../../../shared/ErrorMessage/ErrorMessage';
import RemindersCreateForm from '../RemindersCreateForm/RemindersCreateForm';

const StyledError = styled(ErrorMessage)`
  padding: 16px;
`;
class RemindersCreatePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      reminderTypeLabel: null,
      label: '',
      date: '',
      submitting: false,
    };

    this.updateProperty = (property, value) => {
      this.setState({
        [property]: value,
      });
    };

    this.getSelectedReminderConfig = () => {
      const { myRemindersItemType } = this.props;

      const myRemindersTypes =
        window.DECKEE_CONFIG &&
        window.DECKEE_CONFIG.reminders &&
        JSON.parse(window.DECKEE_CONFIG.reminders.types);

      let myRemindersTypeConfig = myRemindersTypes.find(
        (reminder) => reminder.myRemindersItemType === myRemindersItemType,
      );

      // If we can't find a type, go with prompting the user to create a custom one
      if (myRemindersTypeConfig === undefined) {
        myRemindersTypeConfig = {
          myRemindersItemType: 'custom',
          label: '',
          searchString: 'Create your own',
        };
      }

      this.setState({
        reminderTypeLabel: myRemindersTypeConfig.label,
        label: myRemindersTypeConfig.label,
      });
    };

    this.submit = async () => {
      try {
        this.setState({
          submitting: true,
        });

        const { myRemindersItemType } = this.props;

        const { label, date } = this.state;

        const midnightTimeSting = '00:00:00';
        const expiryDate = +moment(`${date} ${midnightTimeSting}`).format('x');
        const expiryTimezone = moment.tz.guess();

        const reminderData = {
          myRemindersItemType,
          expiryDate,
          expiryTimezone,
          label,
        };

        telemetry(
          telemetry.DEBUG,
          `[RemindersCreatePage.submit] submitting reminder data ${JSON.stringify(
            reminderData,
          )}`,
        );
        // Add the new reminder to the entity store
        const returnedData = await callEndpoint(
          callEndpoint.endpoints.submitReminder,
          { ...reminderData },
        );
        telemetry(
          telemetry.DEBUG,
          `[RemindersCreatePage.submit] received back reminder data ${JSON.stringify(
            returnedData,
          )}`,
        );

        transitionToNextRoute(ROUTE_REMINDERS);

        this.setState({
          submitting: false,
        });
      } catch (error) {
        telemetry(
          /* eslint-disable-next-line no-bitwise */
          telemetry.ERROR | telemetry.NOTIFY_SYSTEM_CHANNEL,
          '[RemindersCreatePage.submit] error submitting reminder',
          error,
        );
        this.setState({
          error: {
            message:
              'There was an error creating the reminder. Please try again soon.',
          },
          submitting: false,
        });
      }
    };
  }

  componentDidMount() {
    const { dispatchSetSideBarNoMenu } = this.props;
    dispatchSetSideBarNoMenu();
    this.getSelectedReminderConfig();
  }

  render() {
    const { error, reminderTypeLabel, submitting, label, date } = this.state;

    return (
      <BasicDrawerLayout
        showMapOverlay
        heading={reminderTypeLabel || ' '}
        onBack={() => transitionToPreviousRoute()}
        onClose={null}
        loading={submitting}
      >
        {error && (
          <StyledError description={(error && error.message) || undefined} />
        )}

        {!submitting && !error && (
          <RemindersCreateForm
            updateField={this.updateProperty}
            submitting={submitting}
            submit={this.submit}
            showDeleteItemButton={false}
            label={label}
            date={date}
          />
        )}
      </BasicDrawerLayout>
    );
  }
}

RemindersCreatePage.propTypes = {
  myRemindersItemType: PropTypes.string.isRequired,
  dispatchSetSideBarNoMenu: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  dispatchSetSideBarNoMenu: () => dispatch(setSideBarNoMenu({})),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RemindersCreatePage);
